import { render, staticRenderFns } from "./DecLiquidity.vue?vue&type=template&id=39946063&scoped=true&"
import script from "./DecLiquidity.vue?vue&type=script&lang=js&"
export * from "./DecLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./DecLiquidity.vue?vue&type=style&index=0&id=39946063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39946063",
  null
  
)

export default component.exports